const log = (...args: any[]) => console.log(...args);

const info = (...args: any[]) => console.info(...args);

const error = (...args: any[]) => console.error(...args);

export default { log, info, error };
